import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.7422 3.02985C15.278 3.1638 15.6038 3.70673 15.4698 4.24253L11.4698 20.2426C11.3359 20.7784 10.793 21.1041 10.2572 20.9702C9.72137 20.8362 9.39561 20.2933 9.52956 19.7575L13.5296 3.75746C13.6635 3.22166 14.2064 2.8959 14.7422 3.02985ZM7.20681 7.29293C7.59733 7.68345 7.59733 8.31662 7.2068 8.70714L4.62102 11.2929C4.23049 11.6834 4.23049 12.3166 4.62102 12.7071L7.2068 15.2929C7.59733 15.6834 7.59733 16.3166 7.2068 16.7071C6.81628 17.0977 6.18312 17.0977 5.79259 16.7071L3.2068 14.1214C2.03523 12.9498 2.03523 11.0503 3.20681 9.87871L5.79259 7.29293C6.18312 6.9024 6.81628 6.9024 7.20681 7.29293ZM17.7926 7.29293C18.1831 6.9024 18.8163 6.9024 19.2068 7.29293L21.7926 9.87871C22.9642 11.0503 22.9642 12.9498 21.7926 14.1214L19.2068 16.7071C18.8163 17.0977 18.1831 17.0977 17.7926 16.7071C17.4021 16.3166 17.4021 15.6834 17.7926 15.2929L20.3784 12.7071C20.7689 12.3166 20.7689 11.6834 20.3784 11.2929L17.7926 8.70714C17.4021 8.31662 17.4021 7.68345 17.7926 7.29293Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }